import React, { useState, useEffect, useRef } from 'react';
import "../AddClients/tableStyle.css"
import { getDoBill } from '../../Services/Services';
import { Input, Form, Button } from 'antd';
import BillFrm from './BillFrm';
import Header from '../Header-Footer/Header';
import { useReactToPrint } from 'react-to-print';
import { FaPrint, FaFileExcel } from 'react-icons/fa';
import Footer from '../Header-Footer/Footer';
import * as XLSX from 'xlsx'; // Import xlsx library
import { Link } from 'react-router-dom';
export default function BillView() {
  const [billList, setbillList] = useState([])
  const [filterBillData, setfilterBillData] = useState([])
  const [billNo, setbillNo] = useState('')
  const [doNo, setdoNo] = useState('')
  useEffect(() => {
    GetDoBill()
  }, [])
  const GetDoBill = async () => {
    const response = await getDoBill({'com_name':localStorage.getItem('com_name')});
    if (response) {
      const sortedArray = [...response].sort((a, b) => b.bill_id - a.bill_id);
      setbillList(sortedArray)
      setfilterBillData(sortedArray)
    }
  }

  
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
 
 
  const handleExportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const wsData = billList.map((e, index) => [
      index + 1,
      e.client_name,
      e.do_no,
      e.bill_no,
      e.pay_amount,
      e.date,
    
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      ['Sr. No', 'Party Name','Do No','Bill No','Pay Amount','Date'],
      ...wsData,
    ]);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'DeliveryOrder');

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, 'Bill List.xlsx');
  };

  useEffect(() => {
    setbillList(filterBillData.filter((res) => res.do_no.toLowerCase().includes(doNo.toLowerCase())))

}, [doNo])

useEffect(() => {
  setbillList(filterBillData.filter((res) => res.bill_no.toLowerCase().includes(billNo.toLowerCase())))

}, [billNo])
const formateDate =(date)=>{
  const [year, month, day] = date.split('-');
  const formattedDate = `${day}-${month}-${year}`;
  return formattedDate
}

  return (
    <div style={{ height:'90vh' }}>
      <Header heading="PARTY PAYMENT VIEW" />
      <Form
        layout="vertical"
      >
        <div className=" grid grid-cols-1 sm:grid sm:grid-cols-3 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%] ">
          <Form.Item
            name="bill_no"
            label={<b>Search Bill Number</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
           <Input placeholder='Search Bill Number' value={billNo}  onChange={(e) => setbillNo(e.target.value)}/>
          </Form.Item>

          <Form.Item
            name="do_no"
            label={<b>Search DO No</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
          <Input placeholder='Search Bill No' value={doNo}   onChange={(e) => setdoNo(e.target.value)}/>
          </Form.Item>
          <Form.Item>
            <br></br>
            <BillFrm setfilterBillData={setfilterBillData} setbillList={setbillList} />
            <Button onClick={handlePrint} style={{ backgroundColor: 'black', color: 'white',top:'5px' }}>
              <FaPrint/>
            </Button>
            <Button onClick={handleExportToExcel} style={{ backgroundColor: 'green', color: 'white', marginLeft: '10px',top:'5px' }}>< FaFileExcel/></Button>

          </Form.Item>
        </div>


      </Form>
      <div className="table-wrapper" ref={componentRef}>
        <table id="my-table" className="w-full">
      {/* <div className="table-container"  ref={componentRef}>
        <table id="my-table" className="w-full relative"> */}
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Sr. No</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Party Name</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Do No</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Bill Id</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Bill No</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base"> Amount</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base"> Bill Date</th>
            
            </tr>
          </thead>
          <tbody>

            {billList.map((e, index) => (

              <tr key={e.index} style={{ backgroundColor: e.rem_qty === 0 ? '#b8ebb8' : '' }}>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{index + 1}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.client_name}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                     {e.do_no}
                
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.bill_id}</td>
              
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.bill_no}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.pay_amount}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{formateDate(e.date)}</td>

              </tr>
            ))}
         
          </tbody>
        </table>
      </div>
      {/* <Footer/> */}
    </div>
  )
}
